import {
  UserOutlined,
  CalendarOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Col, Card, Row } from "antd";
import { formatDateToISO } from "../../util/date-formatter";

interface IMetaDataCard {
  metadata: any;
  title?: string;
  cardBackgroundColor?:string;
}

export const MetaDataCard = ({ metadata, title = "System Information", cardBackgroundColor }: IMetaDataCard) => {
  return (
    <Col span={24}>
      <Card
        className="bg-white rounded-xl shadow-sm [&_.ant-card-body]:px-6 [&_.ant-card-body]:py-4"
        style={{ backgroundColor: cardBackgroundColor ?? undefined }}
      >
        <h4 className="text-gray-800 mb-4 font-semibold">{title}</h4>
        <Row gutter={[16, 16]}>
          {/* Created By */}
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
        <div className="flex items-center">
          <div className="bg-[#F5F5F5] rounded-full p-3 mr-3 text-blue-600">
            <UserOutlined className="text-xl" />
          </div>
          <div>
            <p className="text-gray-500 text-sm mb-1">Created By</p>
            <p className="text-gray-800 font-medium m-0">
          {metadata?.createdBy}
            </p>
          </div>
        </div>
          </Col>

          {/* Created At */}
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
        <div className="flex items-center">
          <div className="bg-[#F5F5F5] rounded-full p-3 mr-3 text-black">
            <CalendarOutlined className="text-xl" />
          </div>
          <div>
            <p className="text-gray-500 text-sm mb-1">Created At</p>
            <p className="text-gray-800 font-medium m-0">
          {formatDateToISO(metadata?.createdAt)}
            </p>
          </div>
        </div>
          </Col>

          {/* Updated By */}
          {
        metadata && metadata.updatedBy && (
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
        <div className="flex items-center">
          <div className="bg-green-50 rounded-lg p-3 mr-3 text-green-600">
            <UserOutlined className="text-xl" />
          </div>
          <div>
            <p className="text-gray-500 text-xs mb-1">Updated By</p>
            <p className="text-gray-800 font-medium m-0">
          {metadata.updatedBy}
            </p>
          </div>
        </div>
          </Col>
        )
          }
          

          {/* Updated At */}
          {
        metadata && metadata.updatedAt && (
           <Col xs={24} sm={12} md={8} lg={6} xl={6}>
        <div className="flex items-center">
          <div className="bg-cyan-50 rounded-lg p-3 mr-3 text-cyan-500">
            <SyncOutlined className="text-xl" />
          </div>
          <div>
            <p className="text-gray-500 text-xs mb-1">Updated At</p>
            <p className="text-gray-800 font-medium m-0">
          {formatDateToISO(metadata.updatedAt)}
            </p>
          </div>
        </div>
          </Col>
        )
          }
         
        </Row>
      </Card>
    </Col>
  );
};
